import { makeActonCreator } from '../util';

export const UPDATE_INITIAL_PROPS = 'UPDATE_INITIAL_PROPS';
export const updateInitialProps = makeActonCreator(UPDATE_INITIAL_PROPS);

export const UPDATE_PAGE_TYPE = 'UPDATE_PAGE_TYPE';
export const updatePageType = makeActonCreator(UPDATE_PAGE_TYPE);
